import React, { useState } from 'react';
import ConfirmDialog from './ConfirmDialog';
import { Edit, Trash2, Router as RouterIcon, MapPin } from 'lucide-react';

function GatewayCard({ gateway, editGateway, deleteGateway }) {
	const [deleteConfirm, setDeleteConfirm] = useState(false);

	const handleDelete = () => {
		if (deleteGateway) setDeleteConfirm(true);
	};

	const deleteYes = async () => {
		await deleteGateway(gateway);
		setDeleteConfirm(false);
	};

	const locationParts = [];
	if (gateway?.location) locationParts.push(gateway.location);
	if (gateway?.latitude != null && gateway?.longitude != null) {
		locationParts.push(`${Number(gateway.latitude).toFixed(4)}, ${Number(gateway.longitude).toFixed(4)}`);
	}

	return (
		<>
			<div className="border border-gray-200 dark:border-gray-700 rounded-xl p-3 flex items-center justify-between gap-2 bg-white dark:bg-gray-900 hover:border-[#880e4f]/50 transition-all text-sm">
				<div className="min-w-0 flex-1">
					<div className="flex items-center gap-2.5 font-medium">
						<RouterIcon size={16} className="text-gray-500 dark:text-gray-400 shrink-0" />
						<span className="truncate">{gateway?.name || gateway?.device_id}</span>
						{gateway?.reference && (
							<span className="text-xs px-1.5 py-0.5 bg-gray-100 dark:bg-gray-800 text-gray-500 dark:text-gray-400 rounded shrink-0">
								{gateway.reference}
							</span>
						)}
					</div>
					{locationParts.length > 0 && (
						<div className="flex items-center gap-1 mt-0.5 ml-[26px] text-xs text-gray-500 dark:text-gray-400 truncate">
							<MapPin size={11} className="shrink-0" />
							<span className="truncate">{locationParts.join(' · ')}</span>
						</div>
					)}
					{gateway?.notes && (
						<div className="mt-0.5 ml-[26px] text-xs text-gray-400 dark:text-gray-500 truncate" title={gateway.notes}>
							{gateway.notes}
						</div>
					)}
				</div>
				<div className="flex gap-1.5 shrink-0">
					<button
						onClick={() => editGateway(gateway)}
						className="p-1.5 text-gray-400 hover:text-[#880e4f] hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg"
					>
						<Edit size={15} />
					</button>
					{deleteGateway && (
						<button
							onClick={handleDelete}
							className="p-1.5 text-gray-400 hover:text-red-500 hover:bg-red-50 dark:hover:bg-red-950 rounded-lg"
						>
							<Trash2 size={15} />
						</button>
					)}
				</div>
			</div>
			{deleteConfirm && deleteGateway && (
				<ConfirmDialog
					open={deleteConfirm}
					title="Delete Gateway?"
					message={`Delete gateway "${gateway?.name || gateway?.device_id}"? This cannot be undone.`}
					yes_text="Delete"
					no_text="Cancel"
					on_yes={deleteYes}
					on_no={() => setDeleteConfirm(false)}
				/>
			)}
		</>
	);
}

export default GatewayCard;
